/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

const DropMoneyStatus = {
  edit: {
    name: 'สแกน',
    color: 'warning',
    icon: 'qr_code_scanner',
  },
  counting: {
    name: 'นับเงิน',
    color: 'info',
    icon: 'hourglass_top',
  },
  photo: {
    name: 'ถ่ายภาพ',
    color: 'info',
    icon: 'camera_alt',
  },
  summary: {
    name: 'ยอดนำส่ง',
    color: 'info',
    icon: 'price_change',
  },
  success: {
    name: 'เสร็จสิ้น',
    color: 'success',
    icon: 'task_alt',
  },
  cancel: {
    name: 'ยกเลิก',
    color: 'error',
    icon: 'cancel',
  },
};

export default DropMoneyStatus;
